import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18d2cb16"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_2 = { class: "mas-table-opt-button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_Wapper = _resolveComponent("Wapper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_mas_table = _resolveComponent("mas-table")!
  const _component_upset_area = _resolveComponent("upset-area")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Wapper, null, {
      default: _withCtx(() => [
        _createVNode(_component_mas_form_main, {
          form: _ctx.form,
          defaultFormFooterConfirmText: "搜索",
          defaultFormFooterButton: ['confirm', 'reset'],
          onConfim: _ctx.confimForm,
          inline: true
        }, {
          content: _withCtx((slotProps) => [
            (_ctx.terminal === 'ops')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "租户",
                  prop: "tenantId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: slotProps.content.tenantId,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantId) = $event),
                      placeholder: "请选择租户"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pocket('TenantAll'), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "搜索区域",
              prop: "queryName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: slotProps.content.queryName,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.queryName) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["form", "onConfim"])
      ]),
      _: 1
    }),
    _createVNode(_component_mas_table, {
      pageConfig: _ctx.paginationInfo,
      tableAttrs: {
    data: _ctx.listData,
  },
      paginationListeners: {
  currentChange: _ctx.onSearch,
  sizeChange: _ctx.sizeChange,
}
    }, {
      "tool-right": _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _ctx.addArea
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_perm, _ctx.areaManageCreatePerm]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          "show-overflow-tooltip": "",
          label: "区域名称",
          "min-width": "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "diabled",
          "show-overflow-tooltip": "",
          label: "区域状态",
          "min-width": "120"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.disabled ? "停用" : "启用"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_ctx.editArea(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": "是",
                "cancel-button-text": "否",
                "icon-color": "red",
                "popper-class": "hbb-work-fff",
                title: _ctx.tipString(scope.row),
                onConfirm: ($event: any) => (_ctx.openOrClose(scope.row))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "text" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.disabled ? "启用" : "停用"), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["title", "onConfirm"])
            ])), [
              [_directive_perm, _ctx.areaManageEditPerm]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["pageConfig", "tableAttrs", "paginationListeners"]),
    _createVNode(_component_upset_area, {
      ref: "upsetArea",
      onOptionSuccess: _ctx.optionSuccess,
      terminal: _ctx.terminal
    }, null, 8, ["onOptionSuccess", "terminal"])
  ], 64))
}